module.exports = FundamentalVue;